export default {
  title: '收藏夹',
  button: {
    create: '新建',
    copy: '复制',
  },
};
